
export default function About() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block mb-4">
            <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
              Tentang Kami
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-6">
            Pusat Layanan Digital Terpadu
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            Bastian Digital Service adalah pusat layanan digital dan servis terpadu yang melayani berbagai kebutuhan UMKM, masjid, sekolah, dan rumah tangga. Dengan pengalaman dan dedikasi tinggi, kami hadir sebagai solusi one-stop untuk semua kebutuhan digital Anda.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-2xl border border-blue-100 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-[#0B1F3B] rounded-2xl mx-auto mb-4">
                <i className="ri-store-2-line text-3xl text-white"></i>
              </div>
              <h3 className="font-bold text-[#0B1F3B] text-xl mb-2">UMKM</h3>
              <p className="text-gray-600 text-sm">Solusi lengkap untuk kebutuhan bisnis Anda</p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-white p-6 rounded-2xl border border-orange-100 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF8A00] rounded-2xl mx-auto mb-4">
                <i className="ri-community-line text-3xl text-white"></i>
              </div>
              <h3 className="font-bold text-[#0B1F3B] text-xl mb-2">Masjid & Sekolah</h3>
              <p className="text-gray-600 text-sm">Layanan khusus untuk institusi pendidikan dan ibadah</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-2xl border border-blue-100 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-[#0B1F3B] rounded-2xl mx-auto mb-4">
                <i className="ri-home-smile-line text-3xl text-white"></i>
              </div>
              <h3 className="font-bold text-[#0B1F3B] text-xl mb-2">Rumah Tangga</h3>
              <p className="text-gray-600 text-sm">Servis dan layanan untuk kebutuhan pribadi</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
